import { where } from 'firebase/firestore';
import { auth } from '../firebase';
import { updateDataById, fetchByTable } from '../utils';

export const updateUser = async (id, data, setLoading) =>
  updateDataById({ id, tableName: 'users', data, setLoading });

export const getLoggedUserProps = async () => {
  const res = await fetchByTable({
    tableName: 'users',
    whereCondition: where('email', '==', auth.currentUser.email),
  });
  if (res.length > 0) {
    return res[0];
  }
  return null;
};

export const fetchStatsByUser = async id =>
  fetchByTable({
    tableName: 'stats',
    whereCondition: where('userId', '==', id),
  });

export const fetchFriends = async (mails = []) => {
  const results = await Promise.all(
    mails.map(mail =>
      fetchByTable({
        tableName: 'users',
        whereCondition: where('email', '==', mail),
      }),
    ),
  );
  return results.flatMap(res => res);
};

export const fetchRequests = async () => {
  const res = await fetchByTable({
    tableName: 'requests',
    whereCondition: where('to', '==', auth.currentUser.email),
  });
  if (res.length > 0) {
    return res;
  }
  return [];
};

export const fetchAllRequests = async setLoading =>
  fetchByTable({ tableName: 'requests', setLoading });

export const fetchFields = async setLoading =>
  fetchByTable({ tableName: 'fields', setLoading });
